// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39243f2b","563":"ff8c4843","891":"da853817"}[chunkId] + ".chunk.js";
};